import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Cookie } from 'lucide-react';
import AppShell from '../../components/layout/AppShell';
import { useLang } from '../../contexts/LangContext';
import { authAPI } from '../../utils/api';

const CookiePolicy = () => {
  const navigate = useNavigate();
  const { lang } = useLang();
  const [user, setUser] = useState(null);
  useEffect(() => { authAPI.getMe().then((r) => setUser(r.data)).catch(() => {}); }, []);
  const today = new Date().toLocaleDateString(lang === 'tr' ? 'tr-TR' : 'en-US');

  return (
    <AppShell user={user} title={lang === 'tr' ? 'Çerez Politikası' : 'Cookie Policy'}>
      <div className="max-w-3xl mx-auto p-4 sm:p-8 md:p-12 space-y-6 text-stone-800">
        <button type="button" onClick={() => navigate(-1)} className="inline-flex items-center gap-1 text-sm text-stone-600 hover:text-stone-900" data-testid="legal-back">
          <ArrowLeft className="w-4 h-4" /> {lang === 'tr' ? 'Geri' : 'Back'}
        </button>

        <header className="space-y-2">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal-50 text-teal-800 text-xs font-semibold uppercase tracking-wider">
            <Cookie className="w-3 h-3" /> {lang === 'tr' ? 'Çerez & LocalStorage' : 'Cookies'}
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>
            {lang === 'tr' ? 'Çerez Politikası' : 'Cookie Policy'}
          </h1>
          <p className="text-sm text-stone-500">{lang === 'tr' ? 'Son güncelleme' : 'Last updated'}: {today}</p>
        </header>

        {lang === 'tr' ? (
          <article className="prose prose-stone max-w-none leading-relaxed space-y-5">
            <p>Hafızım, çalışması için gerekli olan minimum sayıda yerel depolama ve çerez kullanır.</p>

            <h2 className="text-xl font-bold mt-6">Zorunlu (Çalışma için gerekli)</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li><code>hafizim_token</code> (localStorage) — JWT oturum anahtarı. Sayfayı kapatınca devam etmesi için.</li>
              <li><code>hafizim_mode</code> — Yetişkin/Çocuk modu tercihi.</li>
              <li><code>hafizim_lang</code> — Dil tercihi (TR/EN).</li>
              <li><code>hafizim_consent</code> — Çerez bildirimini kapattığınızı hatırlamak için.</li>
            </ul>

            <h2 className="text-xl font-bold mt-6">Tercih (İsteğe bağlı)</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li><code>hafizim_cig_count</code>, <code>hafizim_hifz_mode</code>, <code>hafizim_auto_advance</code> — Hafızlık ayar tercihleri.</li>
              <li><code>hafizim_reciter</code> — Tercih ettiğiniz kari.</li>
              <li><code>hafizim_quran_last_page</code> — Kaldığınız sayfayı hatırlama.</li>
            </ul>

            <h2 className="text-xl font-bold mt-6">Üçüncü taraf</h2>
            <p>Hafızım herhangi bir analitik, reklam veya izleme çerezi kullanmaz. Ses ve metin içerikleri için iletilen istekler tek seferliktir ve kimlik bilgisi içermez.</p>

            <h2 className="text-xl font-bold mt-6">Tarayıcı ayarlarınızla yönetim</h2>
            <p>
              Çerezleri/yerel depolamayı tarayıcı ayarlarınızdan istediğiniz zaman silebilir veya devre dışı bırakabilirsiniz.
              Ancak bu durumda oturum kapanır ve tercihleriniz kaybolur, uygulama doğru çalışmayabilir.
            </p>

            <h2 className="text-xl font-bold mt-6">İletişim</h2>
            <p><a href="mailto:iletisim@hafizim.com" className="text-teal-700 underline">iletisim@hafizim.com</a></p>
          </article>
        ) : (
          <article className="prose prose-stone max-w-none leading-relaxed space-y-5">
            <p>Hafızım uses the minimum number of cookies and local-storage entries required to operate.</p>
            <h2 className="text-xl font-bold mt-6">Strictly necessary</h2>
            <p><code>hafizim_token</code>, <code>hafizim_mode</code>, <code>hafizim_lang</code>, <code>hafizim_consent</code></p>
            <h2 className="text-xl font-bold mt-6">Preferences</h2>
            <p><code>hafizim_cig_count</code>, <code>hafizim_hifz_mode</code>, <code>hafizim_reciter</code>, <code>hafizim_quran_last_page</code></p>
            <h2 className="text-xl font-bold mt-6">No third-party tracking</h2>
            <p>We do not use analytics, advertising, or tracking cookies.</p>
          </article>
        )}
      </div>
    </AppShell>
  );
};

export default CookiePolicy;
